import React from "react";
import { Link, useNavigate } from "react-router-dom";
import imgsun from "../../assets/images/icon/sun.png";
import imgmoon from "../../assets/images/icon/moon.png";
import { useTranslation } from "react-i18next";
import { Avatar, Dropdown, FloatButton, Menu } from "antd";
import i18n from "../../i18n";
import {
  GiftOutlined,
  LogoutOutlined,
  MessageOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { ChairAltOutlined, Support } from "@mui/icons-material";

const User = () => {
  const { t } = useTranslation();
  const role = localStorage.getItem("role");
  const user = JSON.parse(localStorage.getItem("user"));
  const mobile = window.innerWidth < 768;
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const handleChatClick = () => {
    navigate("/client-dashboard/chat");
  };


  return localStorage.getItem("authToken") ? (
    <>
      <Dropdown
        overlay={
          <Menu
            className="dropdown-menu show p-3 shadow rounded-3"
            style={{ width: "320px" }}
          >
            <div className="d-flex flex-column align-items-center text-center p-2">
              <Avatar
                size={50} // smaller avatar
                src={user?.photo_profil}
                icon={!user?.photo_profil && <UserOutlined />}
                className="border border-primary shadow-sm"
              />
              <p
                className="mt-2 mb-0 fw-semibold "
                style={{ fontSize: "1.7rem" }}
              >
                {user?.username}
              </p>
              <p
                className=" mb-0"
                style={{ fontSize: "1.5rem", color: "black !important" }}
              >
                {user?.email}
              </p>
            </div>
            <Menu.Divider />
            {role !== "admin" && role !== "superadmin" && (
              <>
                <Menu.Item
                  className="px-3 py-3 menu-linkk"
                  key="orders"
                  icon={<ShoppingCartOutlined />}
                >
                  <Link to="/client-dashboard/orders" className="menu-linkk">
                    {t("Purchased Orders")}
                  </Link>
                </Menu.Item>
                <Menu.Item
                  className="px-3 py-3 menu-linkk"
                  key="ventes"
                  icon={<ShoppingCartOutlined />}
                >
                  <Link to="/client-dashboard/ventes" className="menu-linkk">
                    {t("Ventes")}
                  </Link>
                </Menu.Item>

                <Menu.Item
                  className="px-3 py-3 menu-linkk"
                  key="coupons"
                  icon={<GiftOutlined />}
                >
                  <Link to="/client-dashboard/coupons" className="menu-linkk">
                    {t("Coupons")}
                  </Link>
                </Menu.Item>

                <Menu.Item
                  className="px-3 py-3 menu-linkk"
                  key="balance"
                  icon={<WalletOutlined />}
                >
                  <Link to="/client-dashboard/balance" className="menu-linkk">
                    {t("Consumable Balance")}
                  </Link>
                </Menu.Item>

                <Menu.Item
                  className="px-3 py-3 menu-linkk"
                  key="settings"
                  icon={<SettingOutlined />}
                >
                  <Link to="/client-dashboard/settings" className="menu-linkk">
                    {t("Settings")}
                  </Link>
                </Menu.Item>
                <Menu.Item
                  className="px-3 py-3 menu-linkk"
                  key="support"
                  icon={<Support />}
                >
                  <Link to="/client-dashboard/chat" className="menu-linkk">
                    {t("Support")}
                  </Link>
                </Menu.Item>

                <Menu.Divider />
              </>
            )}

            {(role === "admin" || role === "superadmin") && (
              <>
                <Menu.Item className="px-3 py-3 menu-linkk" key="2">
                  <Link
                    className="menu-linkk"
                    to="/dashboard"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {t("Dashboard")}
                  </Link>
                </Menu.Item>
                <Menu.Divider />
              </>
            )}
            <Menu.Item
              key="logout"
              icon={<LogoutOutlined />}
              onClick={handleLogout}
              className="px-3 py-3 menu-linkk"
            >
              <span className="menu-linkk">{t("logout")}</span>
            </Menu.Item>
          </Menu>
        }
      >
        <Avatar
          className="hdr-ctrl hdr-user"
          icon={user.photo_profil ? "" : <UserOutlined />}
          style={{
            backgroundImage: user.photo_profil ? `url(${user.photo_profil})` : "",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      </Dropdown>

      {role !== "admin" && role !== "superadmin" && (
        <FloatButton
          icon={<MessageOutlined style={{ color: 'black' }} />}
          type="primary"
          tooltip={t("Support")}
          onClick={handleChatClick}
          style={{
            left: 24,
            bottom: 24,
            width: '50px',
            height: '50px',
            borderRadius: '50%',
            backgroundColor: '#5BF3C7 !important',

            fontSize: '20px',
            fontWeight: 'bold',
            display: 'flex',
          }}
        />
      )}
    </>
  ) : (
    <Link
      to="/signin"
      className="tf-button connect ml-4"
      data-toggle="modal"
      data-target="#popup_bid"
    >
      <i class="bi bi-box-arrow-in-right mt-1"></i>
      <span>{t("login")}</span>
    </Link>
  );

  // <div className="mode-switcher">
  //     <Link className='sun mode-switch' to="#"
  //         onClick={e => switchTheme(e)}  >
  //         <img src={imgmoon} alt="" />
  //     </Link>
  //     <Link className='moon mode-switch' to="#"
  //         onClick={e => switchTheme(e)}  >
  //         <img src={imgsun} alt="" />
  //     </Link>

  // </div>
};

export default User;
